import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';

import withMobileDialog from '@material-ui/core/withMobileDialog';

import PropTypes from 'prop-types';
import Rating from '@material-ui/lab/Rating';
import Typography from '../onepirate/modules/components/Typography';
import StandardButton from '../onepirate/modules/components/StandardButton';

var hash = require('object-hash');

const styles = theme => ({

  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
  dialogTitle: {
    paddingBottom: '15px',
    textAlign: 'center'
  },
  progress: {
    margin: theme.spacing(2),
  },
  divider: {
    marginTop: '20px',
    marginBottom: '20px'
  }
});

class ReviewResultsDialog extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      rating: this.props.rating,
      reviews: this.props.reviews
    };
  }

  render() {

    const { onClose } = this.props;
    const { classes } = this.props;
    const { fullScreen } = this.props;

    console.log(classes);

    return (
      <div>
        <Dialog
          open={true}
          fullWidth
          fullScreen={fullScreen}
          maxWidth="sm"
          scroll='body'
        >
          
          <DialogTitle id="form-dialog-title">
            <Typography variant="subtitle1" color="secondary" className={classes.dialogTitle}>
              Reviews<br/>
         <Rating value={this.state.rating} size="small" readOnly/>
            </Typography>
          </DialogTitle>
          <DialogContent>

            {
              this.state.reviews.map((review, index) => (
                <React.Fragment>
                  {index != 0 && <Divider variant="middle" className={classes.divider}/>}
                  {review.reviewerName}
                  <br/>
                  <Rating value={review.rating} size="small" readOnly/>
                  <br/>
                  {review.feedback}
                  <br/>
                </React.Fragment>
              ))
            }
          </DialogContent>
          <DialogActions>
            <StandardButton color="secondary" onClick={onClose} >
              Close
            </StandardButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ReviewResultsDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withStyles(styles)(withMobileDialog()(ReviewResultsDialog));
